import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelPagamentoProdutor({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<ApiCalculo>> {
	return newRequest({
		url: "Relatorio/PagamentoProdutor",
		type: "get",
		idpk: undefined,
		params,
	});
}
